export default {
  title: '客户管理',
  tab: '客户管理'
}
